import { ReactFlowProvider } from "@xyflow/react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowProvider } from "../../context/FluxogramaContext";
import { Diagrama } from "./diagrama";
import { Box, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { LoadingModal } from "../../components";
import { BarragemData, useBarragemContext } from "../../context";

export const FlowPage = () => {
  const { flowNV } = useParams<{ flowNV: string; }>();
  const { barragem } = useBarragemContext();
  const navigate = useNavigate();

  const [flowId, setFlowId] = useState<number>();

  useEffect(() => {
    if (!barragem || "error" in barragem || "error" in barragem.fluxogramas || !flowNV) return;
    setFlowId(barragem.fluxogramas[flowNV as ('NV0' | 'NV1' | 'NV2' | 'NV3')] ?? -1);

  }, [barragem]);

  if (!flowId) return <LoadingModal open={true} />;

  return <ReactFlowProvider>
    <FlowProvider flowId={flowId}>
      <Box sx={{
        width: "100vw",
        height: "100vh",
        position: "relative",
      }}>
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "35px",
          height: "35px",
          zIndex: 100,
        }}>
          <IconButton onClick={() => navigate(`/app/${(barragem as BarragemData).id ?? -1}/config`)}>
            <Close />
          </IconButton>
        </Box>
        <Diagrama />
      </Box>
    </FlowProvider>
  </ReactFlowProvider>;
};